export type TableHeadKeys<K extends string> = K;

export type FilterFields<K extends string> = Partial<Record<K, string>>;

export function isFiltering(filterOptions: FilterFields<string>): boolean {
  return Object.values(filterOptions).some(Boolean);
}

function isFilterField<K extends string>(field: string, headers: TableHeadKeys<K>[]): field is K {
  return (headers as string[]).includes(field);
}

export const parseFilterParams = <K extends string>(params: URLSearchParams, headers: TableHeadKeys<K>[]) => {
  const filterOptions = {} as FilterFields<K>;

  for (const [key, value] of params) {
    if (isFilterField(key, headers)) {
      filterOptions[key] = value;
    }
  }

  return filterOptions;
};
